var logoutlink = document.getElementById("loggedoutpage");;
if (logoutlink) {
    var link = logoutlink.getAttribute('href');
    window.location.href = link;
}